import i18n from '../i18n';
import pdf from '../assets/files/ROS_AMR_Terms_and_Conditions_2012-02-23_REV_11-29-23_CLEAN_final.pdf';
import { lyonRepairTermsAndConditionsLink, bremenRepairTermsAndConditionsLink } from './returns.const';

const { VITE_REDIRECT_TO_OLD_URL, VITE_FOOTER_LINK_BASE_URL } = import.meta.env;

const getLeftLinks107 = () => [
  {
    link: 'https://www.resmed.com/en-us/legal-ip/',
    linkCaption: i18n.t('footer.intellectualProperty'),
    linkId: 'intellectualProperty',
  },
  {
    link: `${VITE_FOOTER_LINK_BASE_URL}?privacy_policy.html`,
    linkCaption: i18n.t('footer.privacyNotice'),
    linkId: 'privacyNotice',
  },
];

const getLeftLinks116CA = () => [
  // {
  //   link: `${VITE_REDIRECT_TO_OLD_URL}/videotutorial.htm`,
  //   linkCaption: i18n.t('footer.videoTutorials'),
  // },
  {
    link: pdf,
    linkCaption: i18n.t('footer.rosTermsAndConditions'),
    target: '_blank',
    linkId: 'rosTermsAndConditions',
  },
  {
    link: 'https://app.smartsheet.com/b/form/808b7d80eb784e02b33f1a498335c3aa',
    linkCaption: i18n.t('footer.internetApplication'),
    linkId: 'internetApplication',
  },
  {
    link: 'https://www.resmed.com/en-us/legal-ip/',
    linkCaption: i18n.t('footer.intellectualProperty'),
    linkId: 'intellectualProperty',
  },
  {
    link: 'https://www.resmed.com/en-us/healthcare-professional/hcp-privacy-notice/',
    linkCaption: i18n.t('footer.privacyNotice'),
    linkId: 'privacyNotice',
  },
];

const getLeftLinks116 = () => [
  {
    link: pdf,
    linkCaption: i18n.t('footer.rosTermsAndConditions'),
    target: '_blank',
    linkId: 'rosTermsAndConditions',
  },
  {
    link: 'https://app.smartsheet.com/b/form/cfca60e5c8d148149c7123a6dfc487de',
    linkCaption: i18n.t('footer.internetApplication'),
    linkId: 'internetApplication',
  },
  {
    link: 'https://www.resmed.com/en-us/legal-ip/',
    linkCaption: i18n.t('footer.intellectualProperty'),
    linkId: 'intellectualProperty',
  },
  {
    link: 'https://www.resmed.com/en-us/healthcare-professional/hcp-privacy-notice/',
    linkCaption: i18n.t('footer.privacyNotice'),
    linkId: 'privacyNotice',
  },
];

const getLeftLinksTermsEU = (isSRLyonEnable = false) => [
  {
    link: `${VITE_FOOTER_LINK_BASE_URL}?Terms_and_Conditions_EU.html`,
    target: '_blank',
    linkCaption: i18n.t('footer.euTermsAndConditions'),
    linkId: 'euTermsAndConditions',
  },
  {
    link: isSRLyonEnable ? lyonRepairTermsAndConditionsLink : bremenRepairTermsAndConditionsLink,
    linkCaption: i18n.t('footer.euRepairAndMaintenance'),
    linkId: 'euRepairAndMaintenance',
  },
];

const getLeftLinksEU119Base = () => [
  {
    link: 'https://www.resmed.fr/aspects-juridiques-et-propriete-intellectuelle/',
    linkCaption: i18n.t('footer.intellectualProperty'),
    linkId: 'intellectualProperty',
  },
  {
    link: 'https://www.resmed.fr/declaration-de-confidentialite/',
    linkCaption: i18n.t('footer.privacyNotice'),
    linkId: 'privacyNotice',
  },
];

const getLeftLinksNotEU119Base = () => [
  {
    link: 'https://www.resmed.co.uk/legal-and-ip/',
    linkCaption: i18n.t('footer.intellectualProperty'),
    linkId: 'intellectualProperty',
  },
  {
    link: 'https://www.resmed.co.uk/privacy/',
    linkCaption: i18n.t('footer.privacyNotice'),
    linkId: 'privacyNotice',
  },
];

const getLeftLinks = () => [
  // {
  //   link: `${VITE_REDIRECT_TO_OLD_URL}/videotutorial.htm`,
  //   linkCaption: i18n.t('footer.videoTutorials'),
  // },
  {
    link: `${VITE_REDIRECT_TO_OLD_URL}/help/terms_and_conditions_index.html?Terms_and_Conditions_2012-02-23.html`,
    linkCaption: i18n.t('footer.legalDisclaimer'),
    linkId: 'legalDisclaimer',
  },
  {
    link: 'https://app.smartsheet.com/b/form/cfca60e5c8d148149c7123a6dfc487de',
    linkCaption: i18n.t('footer.internetApplication'),
    linkId: 'internetApplication',
  },
  {
    link: 'https://www.resmed.com/en-us/legal-ip/',
    linkCaption: i18n.t('footer.intellectualProperty'),
    linkId: 'intellectualProperty',
  },
  {
    link: 'https://www.resmed.com/en-us/privacy/',
    linkCaption: i18n.t('footer.privacyPolicy'),
    linkId: 'privacyPolicy',
  },
];

const getTermsAUSNZ = () => ({
  link: `${VITE_FOOTER_LINK_BASE_URL}?ResMed_General_Trading_Terms_FINAL_30_10_23_ANZ.html`,
  linkCaption: i18n.t('footer.rosTermsAndConditions'),
  target: '_blank',
  linkId: 'rosTermsAndConditions',
});

const getTermsSGMY = () => ({
  link: `${VITE_FOOTER_LINK_BASE_URL}?Terms_and_Conditions_SG_MY.html`,
  linkCaption: i18n.t('footer.rosTermsAndConditions'),
  target: '_blank',
  linkId: 'rosTermsAndConditions',
});

const getLeftLinksAUSNZ = () => [
  getTermsAUSNZ(),
  ...getLeftLinks107(),
];

const getTermsAP = () => ({
  link: `${VITE_FOOTER_LINK_BASE_URL}?legal_disclaimer_ap.html`,
  linkCaption: i18n.t('footer.rosTermsAndConditions'),
  target: '_blank',
  linkId: 'rosTermsAndConditions',
});

const getLeftLinks107AP = () => [
  getTermsAP(),
  ...getLeftLinks107(),
];

const getLeftLinksSGMY = () => [
  getTermsSGMY(),
  ...getLeftLinks107(),
];

const getLeftLinksEU119 = (isSRLyonEnable) => [
  ...getLeftLinksTermsEU(isSRLyonEnable),
  ...getLeftLinksEU119Base(),
];

const getLeftLinksEU = (isSRLyonEnable) => [
  ...getLeftLinksTermsEU(isSRLyonEnable),
  ...getLeftLinksNotEU119Base(),
];

const getRightLinks = (resmedUrl) => [
  {
    link: resmedUrl,
    linkCaption: i18n.t('footer.resmed'),
    target: '_blank',
    linkId: 'Footer-LNK-Resmedlink',
  },
  {
    link: '/contact-us',
    internal: true,
    linkCaption: i18n.t('footer.contactUs'),
    linkId: 'contactUs',
  },
  {
    link: 'https://resmedwebinars.com/',
    linkCaption: i18n.t('footer.webinars'),
    target: '_blank',
    linkId: 'webinars',
  },
];

const FOOTER_LINKS = {
  getLeftLinks,
  getLeftLinks116,
  getLeftLinks116CA,
  getLeftLinks107AP,
  getLeftLinksAUSNZ,
  getLeftLinksSGMY,
  getLeftLinksEU119,
  getLeftLinksEU,

  getRightLinks: () => getRightLinks('https://www.resmed.com/en-us/'),
  getRightLinks107AP: () => getRightLinks('https://www.resmed.com/'),
  getRightLinksEU: () => getRightLinks('https://www.resmed.co.uk/'),
  getRightLinksEU119: () => getRightLinks('https://www.resmed.fr/'),
};

export default FOOTER_LINKS;
